// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"367":"23906d61","561":"9e1b838b","668":"3b2bffb2","728":"7abaf2f6","752":"4e877882","809":"26251108"}[chunkId] + ".chunk.js";
};